export const environment = {
            production: true,
            api: 'https://api-escogecuidarte.ssj.gob.mx/api/'
  };
  